import { render, staticRenderFns } from "./LoadingDataFetch.vue?vue&type=template&id=49888344&scoped=true&"
import script from "./LoadingDataFetch.vue?vue&type=script&lang=js&"
export * from "./LoadingDataFetch.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDataFetch.vue?vue&type=style&index=0&id=49888344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49888344",
  null
  
)

export default component.exports